import $ from "jquery";
import { csl, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
const { app } = window;

/*****************
*  add app util  *
*****************/
Object.assign(app, {
	/**
	 * GET値から検索条件に対応するものを抽出
	 * @param {Boolean} includeSort
	 * @returns {Object}
	 */
	getFiltered(includeSort) {
		const confSrch = this.module.config.search || {};
		const keys = u_.isObject(this._GET) ? Object.keys(this._GET) : [];
		const fltr = {};
		
		keys.forEach(k => {
			const pk = (k === this.fm.search.keywordQuery) ? "KEYWORD" : k;
			if( confSrch[pk] || (/_to$|_from$/).test(pk) ) {
				fltr[pk] = this._GET[k];
			}
		});
		
		if(includeSort && keys.indexOf("sort") >= 0) {
			fltr.sort = this._GET.sort;
		}
		
		return fltr;
	},
	
	/*----------------
	* リストを生成
	* @return Promise
	*/
	/**
	 * リストを生成
	 *
	 * @param {Function} callback
	 * @returns Promise
	 */
	async initList(callback) {
		const dataKey = this.module.getDataKey();
		const { config } = this.module;
		
		// フィルタ情報を取得
		config.fltrs = this.getFiltered(true);
		
		// ** beforeコールバックの実行 **
		if( u_.isFunction(this.beforeInitList[dataKey]) ) {
			const res = await this.beforeInitList[dataKey].call(
				this.module,
				config,
				config.fltrs
			);
			
			if(res === false) {
				// キャンセル
				csl.log.grey("** initList is canceled. **");
				return res;
			}
		}
		
		if( u_.isFunction(this.beforeInitList.always) ) {
			const res = await this.beforeInitList.always.call(
				this.module,
				config,
				config.fltrs
			);
			
			if(res === false) {
				// キャンセル
				csl.log.grey("** initList is canceled. **");
				return res;
			}
		}
		
		
		// フィルタ条件の反映
		const { getFilter } = this.module;
		getFilter.conditions = this.fm.search.createConditions(config.fltrs);
		if( !getFilter.conditions.length ) {
			delete getFilter.conditions;
		}
		
		// sortの反映
		const $header = vuwer.get("header.dataTable.listSection").$self;
		$header.find(".is-sorted").removeClass("is-sorted");
		if(config.fltrs.sort) {
			const arr = config.fltrs.sort.split(",");
			const isDesc = (arr.pop() === "desc") ? true : false;
			const sortKey = arr.join(",");
			const sortPk = arr.pop();
			
			if( u_.isObject(config.dataParams[sortPk]) || sortPk === "dateUpd" ) {
				let sortFlags;
				
				if(sortPk === "itemId") {
					sortFlags = "numeric";
				} else
				if(sortPk === "dateUpd") {
					sortFlags = "natural";
				} else {
					switch(config.dataParams[sortPk].inpType) {
						case "date":
						case "datetime":
						case "period": {
							sortFlags = "natural";
							break;
						}
						
						case "number":
						case "flg": {
							sortFlags = "numeric";
							break;
						}
						
						case "radio":
						case "checkbox":
						case "select": {
							const { dataOption } = config.dataParams[sortPk];
							sortFlags = Array.isArray(dataOption) ? "numeric" : "string";
							break;
						}
						
						default: {
							sortFlags = "string";
							break;
						}
					}
				}
				
				getFilter.sort = {
					sortKey: sortKey,
					isDesc: isDesc,
					sortFlags
				};
				
				$header.find(`#sort_${sortPk}`)
				.children(isDesc ? ".desc" : ".asc").addClass("is-sorted");
				
			} else {
				// デフォルト（サーバーから受け取ったままの状態）
				const objSort = this.sortDefault[dataKey] || {
					sortKey: "itemId",
					isDesc: true
				};
				
				$header.find(`#sort_${objSort.sortKey}`)
				.children(objSort.isDesc ? ".desc" : ".asc").addClass("is-sorted");
			}
			
		} else {
			// デフォルト（サーバーから受け取ったままの状態）
			const objSort = this.sortDefault[dataKey] || {
				sortKey: "itemId",
				isDesc: true
			};
			
			$header.find(`#sort_${objSort.sortKey}`)
			.children(objSort.isDesc ? ".desc" : ".asc").addClass("is-sorted");
		}
		
		// リストのbody部分を生成し、DOMに追加
		const response = await this.module.initList();
		
		// プレビュー用のテンプレートが未設定の場合はプレビューボタンを削除
		const { $areaList } = this.module;
		if(!this.preview.hasTemplate) {
			$areaList.find(".btn-preview").remove();
		}
		$areaList.parent().toggleClass("no-preview", !this.preview.hasTemplate);
		
		
		// (ユーザー管理の場合の例外処理）
		if(dataKey === "users") {
			const { account } = this.config;
			const $self = $(`#item_${account.itemId}`);
			const className = `lv-${account.lv} type-select`;
			
			$self.children(".col-lv").append(
				$("<span/>").addClass(className).text(account.lvDisp)
			);
			$self.find(".btn-delete").addClass("is-disable");
		}
		
		// コールバックの実行
		if( u_.isFunction(this.initListCallBacks[dataKey]) ) {
			const res = await this.initListCallBacks[dataKey].call(
				this.module,
				$areaList,
				config,
				response
			);
			
			if(res === false) {
				return res;
			}
		}
		
		if( u_.isFunction(this.initListCallBacks.always) ) {
			const res = await this.initListCallBacks.always.call(
				this.module,
				$areaList,
				config,
				response
			);
			
			if(res === false) {
				return res;
			}
		}
		
		if( u_.isFunction(callback) ) {
			const res = await callback.call(
				this.module,
				$areaList,
				config,
				response
			);
			
			if(res === false) {
				return res;
			}
		}
		
		return true;
	}
});
